<!-- Instagram Stories (mobile) -->
<div class="mst">
  <div class="mst-screen">
    <app-meta-creative class="mst-creative" [src]="data.creative" [kind]="data.creativeKind" slot="story"></app-meta-creative>
    <div class="mst-scrim"></div>
    <div class="mst-progress"></div>

    <div class="mst-header">
      <img class="mst-avatar" [src]="avatar" alt="" />
      <div class="mst-identity">
        <div class="mst-name">{{ accountName }}<i class="bi bi-patch-check-fill mst-verified"></i></div>
      </div>
      <div class="mst-header-icons">
        <i class="bi bi-three-dots"></i>
        <i class="bi bi-x-lg"></i>
      </div>
    </div>

    <a class="mst-link" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
      <span class="mst-cta"><i class="bi bi-link-45deg"></i><span>{{ cta }}</span></span>
    </a>
  </div>

  <div class="mst-bottom-bar">
    <span>Oglas</span>
    <span class="mst-bottom-icons">
      <i class="bi bi-heart"></i>
      <i class="bi bi-chat"></i>
      <i class="bi bi-send"></i>
    </span>
  </div>
</div>
